// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (c) 2026 Password Manager contributors
// TODO: Implement for password manager
export const LanguageService = {
  getPreferredLanguage: async (): Promise<string | null> => null,
  updatePreferredLanguage: async (_language: string): Promise<void> => {},
};

export function getLanguages() {
  return [];
}

export function setLanguage(_language: string) {}
